import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useNavigate, useLocation } from "react-router-dom";

import { AppContext } from '../../context/AppContext';
import { Button, Headline, TextInput, Select } from '../../elements';
import { Layout } from '../../components';

import { ELEVATOR_PAGE, ROOT, BUILDING_PAGE, OVERVIEW } from '../../navigation/routes';
import { UPDATE_CONFIGURATION, UPDATE_LEAD } from '../../context/ActionTypes';
import { buildingTypes } from '../../data/options.json';
import styles from  './BuildingPage.module.scss';

const BuildingPage = () => {
	const { state, dispatch } = React.useContext(AppContext);
	const {
		register,
		handleSubmit,
		formState: { errors },
		control,
	} = useForm({ criteriaMode: 'all', mode: 'onSubmit' });
	const navigate = useNavigate();
	const isEdit = useLocation().pathname === `${BUILDING_PAGE}/edit`;

	const onSubmit = (data) => {
		 const { zip, street, city, buildingType } = data;
		
		dispatch({
			type: UPDATE_CONFIGURATION,
			payload: { buildingType },
		});

		dispatch({
			type: UPDATE_LEAD,
			payload: { zip, street, city },
		})

		if (state.configuration.elevators.length >= 1) navigate(OVERVIEW);
		else navigate(ELEVATOR_PAGE);
	};

	return (
		<Layout>
			<Headline variant='h2'>Informationen zum Gebäude</Headline>

			<form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
				<TextInput
					type='text'
					label='Straße / Hausnummer'
					errors={errors}
					defaultValue={state.lead.street}
					{...register('street', { required: true })}
				/>

				<TextInput
					type='text'
					label='Postleitzahl'
					errors={errors}
					defaultValue={state.lead.zip}
					maxLength={5}
					{...register('zip', {
						required: true,
						minLength: 5,
					})}
				/>

				<TextInput
					type='text'
					label='Stadt'
					errors={errors}
					defaultValue={state.lead.city}
					{...register('city', { required: true })}
				/>

				<Controller
					control={control}
					name='buildingType'
					rules={{ required: true }}
					defaultValue={state.configuration.buildingType ? state.configuration.buildingType : ''}
					render={({ field }) => (
						<Select
							inputRef={field.ref}
							label='Gebäudetyp'
							options={buildingTypes}
							name={field.name}
							value={
								field.value
									? buildingTypes.find((opt) => opt.value === field.value).label
									: null
							}
							onChange={(val) => field.onChange(val)}
							errors={errors}
						/>
					)}
				/>

				<div className={styles.footer}>
					<Button type='button' title={isEdit ? 'Abbrechen' : 'Zurück'} variant="outline" onClick={() => navigate(isEdit ? OVERVIEW : ROOT)} />
					<Button type='submit' title={isEdit ? 'Speichern' : 'Weiter'} />
				</div>
			</form>
		</Layout>
	);
};

export default BuildingPage;
